import { render, staticRenderFns } from "./SiteSearchBarSuggestion.vue?vue&type=template&id=720d7b31&"
import script from "./SiteSearchBarSuggestion.vue?vue&type=script&lang=ts&"
export * from "./SiteSearchBarSuggestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports